module.exports = __webpack_public_path__ + "img/logo-dark-theme.710913c5.svg";